import { FunctionComponent, useCallback, useEffect, useState } from 'react'

import { useQueryClient } from '@tanstack/react-query'
import Script from 'next/script'

import config from '@config'
import useCMPHasUserInteracted from '@hooks/useCMPHasUserInteracted'

const {
  video: { playerScript },
} = config

const VideoManager: FunctionComponent = () => {
  const queryClient = useQueryClient()
  const [loadLibrary, setLoadLibrary] = useState(false)

  const onJWPlayerScriptLoaded = useCallback(() => {
    queryClient.setQueryData(['has-jwplayer-script-loaded'], true)
    queryClient.invalidateQueries({
      queryKey: ['has-jwplayer-script-loaded'],
      exact: true,
    })
  }, [queryClient])

  useEffect(() => {
    queryClient.setQueryData(['trigger-jwplayer-script-loading-func'], {
      load: () => setLoadLibrary(true),
    })
  }, [queryClient])

  const hasUserInteracted = useCMPHasUserInteracted()

  return hasUserInteracted && loadLibrary ? (
    <Script
      id="JWPlayer"
      strategy="afterInteractive"
      defer={true}
      src={playerScript}
      onLoad={onJWPlayerScriptLoaded}
    />
  ) : null
}

export default VideoManager
